import { DocumentType } from '@backrs_ui/grow-ui/src/models/models';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth, lubavAppBaseQuery } from '../baseQuery';

export type DocumentInfo = Readonly<{
  filename: string | null;
  url: string | null;
  created_at?: string;
  updated_at?: string;
  s3_key?: string;
}>;

export type UserDocuments = Readonly<{
  [key in DocumentType]: DocumentInfo[];
}>;

type CheckUserDocumentsParams = Readonly<{
  documents: DocumentType[];
  userId?: string;
}>;

export const userDocumentsApi = createApi({
  reducerPath: 'userDocumentsApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    checkUserDocuments: build.query<UserDocuments, CheckUserDocumentsParams>({
      query: ({ documents, userId }) => {
        const searchParams = new URLSearchParams();

        documents.forEach((doc) => searchParams.append('documents[]', doc));

        if (userId) {
          searchParams.append('user_id', userId);
        }

        return {
          url: `/profile/documents?${searchParams.toString()}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const userLubavApi = createApi({
  reducerPath: 'userLubavApi',
  baseQuery: lubavAppBaseQuery,
  endpoints: (build) => ({
    getUserSimilarities: build.query<string, { user_id_1: number; user_id_2: number }>({
      query: ({ user_id_1, user_id_2 }) => {
        const searchParams = new URLSearchParams();

        searchParams.append('user_id_1', user_id_1.toString());
        searchParams.append('user_id_2', user_id_2.toString());

        return {
          url: `/api/get-user-similarities?${searchParams.toString()}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useCheckUserDocumentsQuery } = userDocumentsApi;
export const { useGetUserSimilaritiesQuery } = userLubavApi;
